export default __webpack_public_path__ + "6e89cace745b6ffaba73964bb988fbfd.svg";